
import { useState } from "react"
import { egyptsOption, egyptsUpgrade } from "../../../../data/upgrade/egypts"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const EgyptsUpgrade = (props) => {
    const selectList = egyptsOption
    const lvl = Array.from({ length: 20 }, (_, index) => ({ id: index + 1, name: `Level ${index + 1}` }));

    const [selectValue, setSelectValue] = useState({name:"", lvl:"1"})
    const handleSelectName = event => {
        setSelectValue(prevState => ({ name: event.target.value, lvl: prevState.lvl }));
    } 
    const handleSelectLvl = event => {
        setSelectValue(prevState => ({ ...prevState, lvl: event.target.value }));
    }
    
      
    function vypis(){
        const selectedEgyptUpgrade = egyptsUpgrade[selectValue.name - 1][selectValue.lvl-1]
        const item =[{id:1,
                      name: egyptsOption[selectValue.name - 1].name + " " + selectedEgyptUpgrade.level ,
                      wood: selectedEgyptUpgrade.wood,
                      clay: selectedEgyptUpgrade.clay,
                      iron: selectedEgyptUpgrade.iron,
                      crop: selectedEgyptUpgrade.crop,
                      all: selectedEgyptUpgrade.all}]
        props.addItem(item[0])
    }
    

    
    return(
        <div>
            <ListSelect label="...choose a trop" selectList={selectList} handleSelectValue={handleSelectName} />
            <ListSelect label="...choose a level" selectList={lvl} handleSelectValue={handleSelectLvl}/>
            {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}
           

        </div>
    )
}
export default EgyptsUpgrade